import React, { useState, useEffect } from 'react';
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import * as settingsAction from "store/entities/settingsInfo/action";
import * as notificationAction from "store/entities/notification/action";

import days from "data/days"
import FormDrawer from './form-drawer';
import { SelectInput } from "components/__new/common/form";
import validate from "utils/validate";
import useLoginInfo from 'hooks/useLoginInfo';
import ReactTooltip from 'react-tooltip'
import { ReactComponent as IconInfo } from "assets/images/icons/project-icons/caution.svg";



const OnDemandPayModal = (props) => {
const {isOpen, setIsOpen} = props;
const dispatch = useDispatch();

const {userInfo} = useLoginInfo();

const {companyInfo, updateODPConfiguration, updateODPConfigurationLoading} = useSelector((s) => s.entities.settingsInfo);


const [form, setForm] = useState({
    payrollCutOff: companyInfo?.company?.payrollCutOff || '',
    paymentFee: companyInfo?.company?.paymentFee || '',
    autoWithdrawals: companyInfo?.company?.autoWithdrawals || '',
    withdrawalPercent: companyInfo?.company?.withdrawalPercent || ''
});;

const handleODPChange = (e) => {
    const { name, value } = e.target;
    setForm(prevForm => ({
        ...prevForm,
        [name]: value
    }));
};


const submitForm = async (e) => {
    e.preventDefault();
    
    const errors = validate(form);
    if (errors){
        for (var x in errors) {
            toast.error(errors[x]);
        };
        return;
    }
    else{
        const params = {
        payrollCutOff: form.payrollCutOff,
        withdrawalPercent: form.withdrawalPercent,
        autoWithdrawals: form.autoWithdrawals,
        paymentFee: form.paymentFee
    }
    
        dispatch(settingsAction.updateODPConfiguration(params));
        setIsOpen(false);
    }
    setIsOpen(false);
}

useEffect(() => {
    if(updateODPConfiguration?.status === "success"){
        dispatch(settingsAction.getInfo(userInfo?.company?.selectedCompanyId));
        dispatch(notificationAction.getAllNotifications());
    }
    //eslint-disable-next-line
}, [updateODPConfiguration]);

    return (
        <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={setIsOpen}>
            <form className="p-6" onSubmit={submitForm}>
                <FormDrawer.Title
                    title="Edit On-Demand Pay Configuration"
                    description="Configure your On-Demand Pay settings"
                    showCloseButton={true}
                    close={setIsOpen}
                />
                
                <hr />
                    
                <div className='py-4 text-ep-gray-700 font-medium'>
                    <SelectInput 
                        label="Salary Date" 
                        name="payrollCutOff"
                        value={form.payrollCutOff} 
                        onChange={handleODPChange}
                    >
                        <option value="">Select</option>
                        {days.map(({day, value}, index) => <option key={index} value={value}>{day}</option>)}                                 
                    </SelectInput>    
                    <SelectInput 
                        label="Withdrawal Fee" 
                        name="paymentFee"
                        value={form.paymentFee} 
                        onChange={handleODPChange}
                    >
                        <option value="">Select</option>
                        <option value="employer">Employer</option>
                        <option value="employee">Employee</option>
                    </SelectInput>
                    <div className='w-full relative'>
                        <SelectInput 
                            label="Withdrawal Setup" 
                            // id="Withdrawal Setup" 
                            name="autoWithdrawals"
                            value={form.autoWithdrawals} 
                            onChange={handleODPChange}
                        >
                            <option value="">Select</option>
                            <option value={true}>Allow Auto Withdrawal</option>
                            <option value={false}>Require Approval</option>
                        </SelectInput>
                        <button type='button' data-tip data-for="withdrawal-setup" className='pr-2 cursor-pointer absolute top-0' style={{left: "120px"}}><IconInfo /></button>
                        <ReactTooltip  place='bottom' id="withdrawal-setup" type='light' backgroundColor='#fff' className="tooptip-size text-left py-3 px-4 rounded-2.5 text-ep-gray-300">
                                <ol style={{maxwidth: "456px", fontSize: '16px', lineHeight: '19.2px' }}>
                                    <li>1. Allow auto-withdrawals (with description saying : <br/>employee can access their<br/> on-demand-salary without requiring any<br/>  approval)</li>
                                    <li>2. Require approval (with a description to<br/>  say "i will approve each withdrawal from<br/>  my employee before they have access")</li>
                                </ol>
                        </ReactTooltip>
                    </div>
                    <div className="w-full relative">
                        <SelectInput 
                            label="Employee Access (Percentage)" 
                            name="withdrawalPercent"
                            value={form.withdrawalPercent}  
                            onChange={handleODPChange}
                            // tooltip="This is the percenatge that an On-Demand Pay Employee can access"
                        >
                            <option value="">Select</option>
                            <option value={50}>50%</option>
                            <option value={75}>75%</option>
                        </SelectInput>
                        <button type='button' data-tip data-for="employee-access" className='pr-2 cursor-pointer absolute top-0' style={{left: "204px"}}><IconInfo /></button>
                        <ReactTooltip  place='bottom' id="employee-access" type='light' backgroundColor='#fff' className="tooptip-size text-left py-3 px-4 rounded-2.5 text-ep-gray-300">
                                <div style={{maxwidth: "456px", fontSize: '16px', lineHeight: '19.2px' }}>
                                This is the percenatge that an On-<br/>Demand Pay Employee can acess
                                </div>
                        </ReactTooltip>
                    </div>
                </div>
                <div className="p-1 mt-4 flex justify-end space-x-3">
                    <button onClick={setIsOpen} type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white"                    >
                        Cancel
                    </button>
                    <button type="submit" disabled={updateODPConfigurationLoading} className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-white bg-ep-primary-600">
                        Save Changes
                    </button>
                </div>
                
            </form>
        </FormDrawer>
  )
}

export default OnDemandPayModal